const state = {
  benefitCategories: [],
  benefitCategory: {},
};

export default state;
